import { createContext, useContext, useMemo, useState } from 'react';

import Dialog from 'core/ui/Dialog';

import EntityHistory, { HistoryEntity } from './EntityHistory';

const ctx = createContext<TContextValue | null>(null);
export const useHistoryModal = (): TContextValue => orDie(useContext(ctx));

type TContextValue = {
  showWordHistory: (wordUid: string) => void;
  showQuestionHistory: (questionUid: string) => void;
};

export function WithHistoryModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [entity, setEntity] = useState<HistoryEntity | null>(null);
  const api = useMemo(
    (): TContextValue => ({
      showWordHistory: (wordUid: string) =>
        setEntity({ entity: 'word', uid: wordUid }),
      showQuestionHistory: (questionUid: string) =>
        setEntity({ entity: 'question', uid: questionUid }),
    }),
    []
  );

  return (
    <ctx.Provider value={api}>
      {children}
      <Dialog isOpen={!!entity}>
        {entity && (
          <EntityHistory entity={entity} closeDialog={() => setEntity(null)} />
        )}
      </Dialog>
    </ctx.Provider>
  );
}
